export default __webpack_public_path__ + "static/media/course.55359e31.jpeg";